import React, {Component} from 'react';
import './TabberTab.css';
import PropTypes from 'prop-types';
import {Redirect} from "react-router-dom";

export default class TabberTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null
        };
    }

    handleOnClick() {
        if (this.props.redirectTo) {
            this.setState({
                redirectTo: this.props.redirectTo
            });

            setTimeout(() => {
                this.setState({
                    redirectTo: null
                });
            }, 0);
        }

        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    render() {
        let redirectRender = (null);

        if (this.state.redirectTo) {
            redirectRender = (<Redirect to={this.state.redirectTo}/>);
        }

        let classNames = ["TabberTab"];

        if (this.props.isActive) {
            classNames.push("TabberTab--active");
        }

        return (
            <div className={classNames.join(' ')} onClick={this.handleOnClick.bind(this)}>
                {redirectRender}
                {this.props.icon || null}
                <span className={"TabberTab__label"}>{this.props.label}</span>
            </div>
        );
    }
}

TabberTab.propTypes = {
    label: PropTypes.string.isRequired,
    redirectTo: PropTypes.string,
    onClick: PropTypes.func,
    isActive: PropTypes.bool.isRequired,
    icon: PropTypes.any
};



// WEBPACK FOOTER //
// ./src/Portal/Parts/TabberTab.js